import CardSystem from '../CardSystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import RockCard from '../../../Prototype/Level/Card/RockCard';
import { Anim, StartAnimationClip } from '../../Animation/AnimationHelper';
import { DragonbonesDefault } from '../../Animation/Clip';

export default function RockCardUpdateAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData,
): void {
    const sourceCard: RockCard = system.getCardByID(taskData.cards[0]) as RockCard;
    const prevPickaxesAmount = sourceCard.getPrevPickaxesAmount();

    if (prevPickaxesAmount === taskData.pickaxesAmount) return;

    const pickaxesAmountText = sourceCard.getPickaxesAmountText();
    sourceCard.updatePickaxesAmountText(taskData.pickaxesAmount);

    Anim(pickaxesAmountText, { scaleX: 1.2, scaleY: 1.2, duration: 200, yoyo: true, delay: 200 });

    StartAnimationClip(
        new DragonbonesDefault(sourceCard.getArmature(), {
            animationName: 'countdown',
            playTimes: 1,
        }),
    );
}
